import { Filter, FilterProps } from '@otp/ui';

type FieldOfficeCountOtpReportFilterProps = Omit<FilterProps, 'items'>;

export const FieldOfficeCountOtpReportFilter = ({
  ...props
}: FieldOfficeCountOtpReportFilterProps) => {
  return (
    <div className="flex justify-between">
      <Filter
        {...props}
        items={[]}
        searchInputProps={{
          placeholder: 'Search',
        }}
      />
    </div>
  );
};
